export const description =
  "Remplacer ses fenêtres par du double vitrage VIR (Uw ≤ 1,3) supprime 10 à 15 % des déperditions. Aides cumulables MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 %.";
